const GroupMetric = Object.freeze({
  BRAND_POSTS: 'BRAND_POSTS',
  ENGAGEMENTS: 'ENGAGEMENTS',
  LIKES: 'LIKES',
  SHARES: 'SHARES',
  COMMENTS: 'COMMENTS',
  FOLLOWERS: 'FOLLOWERS',
  VIEWS: 'VIEWS',
  VIEW_RATE: 'VIEW_RATE',
  FOLLOWERS_BY_POSTS: 'FOLLOWERS_BY_POSTS',
  ENGAGEMENT_RATE: 'ENGAGEMENT_RATE',
  APPLAUSE_RATE: 'APPLAUSE_RATE',
  CONVERSATION_RATE: 'CONVERSATION_RATE',
  AMPLIFICATION_RATE: 'AMPLIFICATION_RATE',
  ENGAGEMENT_RATE_PER_FOLLOWERS: 'ENGAGEMENT_RATE_PER_FOLLOWERS',
  APPLAUSE_RATE_PER_FOLLOWERS: 'APPLAUSE_RATE_PER_FOLLOWERS',
  CONVERSATION_RATE_PER_FOLLOWERS: 'CONVERSATION_RATE_PER_FOLLOWERS',
  AMPLIFICATION_RATE_PER_FOLLOWERS: 'AMPLIFICATION_RATE_PER_FOLLOWERS',
  VIEW_RATE_PER_FOLLOWERS: 'VIEW_RATE_PER_FOLLOWERS'
} as const)
export default GroupMetric
export type GroupMetricStrings = typeof GroupMetric[keyof typeof GroupMetric]
// RESERVE BELOW
